<template lang="html">
  <UModal v-model:open="isOpen" :fullscreen="isMobile" dismissible>
    <template #content>
      <div class="search-modal relative flex flex-col gap-4 p-4">
        <UButton
          v-if="isMobile"
          icon="i-lucide-x"
          color="neutral"
          variant="ghost"
          class="absolute top-2 right-2"
          @click="isOpen = false"
        />

        <h2 v-if="isMobile" class="text-xl font-semibold">
          Поиск
        </h2>

        <div class="search-modal__input flex items-center gap-2">
          <UInput
            v-model="queryModel"
            placeholder="Поиск..."
            :autofocus="true"
            class="w-full"
            @keydown.enter="goToSearch"
          >
            <template #leading>
              <UIcon name="i-lucide-search" />
            </template>
            <template #trailing>
              <UButton
                v-if="queryModel"
                color="neutral"
                variant="link"
                size="sm"
                icon="i-lucide-x"
                @click="clearQuery"
              />
            </template>
          </UInput>

          <UButton icon="i-lucide-search" @click="goToSearch" />
        </div>

        <SearchSuggests
          v-if="debouncedQuery"
          :query="debouncedQuery"
          @select="isOpen = false"
        />

        <div
          v-else-if="isMobile"
          class="search-modal__cta flex flex-col items-center justify-center gap-4 py-10 text-center"
        >
          <img src="/None.svg" alt="" class="h-40 w-40">
          <p class="text-xl font-bold">
            Введите свой запрос
          </p>
        </div>
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
import { useMediaQuery } from '@vueuse/core'
import { debounce } from 'lodash-es'

import SearchSuggests from './SearchSuggests.vue'

const props = defineProps<{
  open: boolean
}>()

const emit = defineEmits<{
  'update:open': [value: boolean]
}>()

const { routing } = useProducts()
const isMobile = useMediaQuery('(max-width: 640px)')
const route = useRoute()

watch(
  () => route.path,
  () => {
    isOpen.value = false
  },
)

const query = ref('')
const debouncedQuery = ref('')

const queryModel = computed({
  get: () => query.value,
  set: (value: string) => {
    query.value = value
    debouncedSetQuery(value)
  },
})
const isOpen = computed({
  get: () => props.open,
  set: value => emit('update:open', value),
})

const debouncedSetQuery = debounce((value: string) => {
  debouncedQuery.value = value
}, 300)

const clearQuery = () => {
  query.value = ''
  debouncedQuery.value = ''
}

const goToSearch = () => {
  if (!query.value.trim()) return

  isOpen.value = false
  navigateTo(routing.getSearch(query.value.trim()).route)
}
</script>
